import camelcaseKeys from 'camelcase-keys';
import { buildHeaders, buildUrl, fetchRequest } from '@/api/utils/RestApi';

export interface AlgoliaCredentials {
  applicationId: string;
  apiKey: string;
}

export const getAlgoliaCredentials = async (): Promise<AlgoliaCredentials> => {
  const url = buildUrl('REPAIR_CATALOG', 'v1/algolia');
  const headers = buildHeaders('REPAIR_CATALOG');
  const response = await fetchRequest({ url, method: 'GET', headers });
  return camelcaseKeys<AlgoliaCredentials>(await response.json());
};
